export default __webpack_public_path__ + "static/media/alert--red.1ac9b626.svg";